import { useCallback, useState } from 'react';
import useSWR from 'swr';
import { CloseReasons } from '@shared/components/modals/Modal';
import { queryParams } from '@shared/commonFunctions';
import { AlertModal } from '@shared/components/modals/AlertModal';
import { SERVICES } from '@shared/constants/apiConfig';

import { IAsset } from '../../../Assets/interfaces';
import { requestUpdateAsset } from '../../../Assets/requests';
import { IDocumentGenerate, ITitleAlertProps, MENU_ITEMS } from './interface';
const EMAIL = 'email';
const STIPS = 'stips';

export const TitleAlert = ({
  setOpenTitleAlert,
  onDocGenerate,
  docMenuItem,
  assetId,
  contact,
  filterDocumentTypeIds
}: ITitleAlertProps) => {
  const params = queryParams();
  const [contactState, setContactState] = useState('');
  const [nameMatchAlert, setNameMatchAlert] = useState(true);
  const [stateMatchAlert, setStateMatchAlert] = useState(false);
  const { data: asset } = useSWR<IAsset>(assetId && `${SERVICES.ASSET}/assets/${assetId}`);

  const isMenuItemNeedAction = useCallback((type: string, id: number): boolean => {
    return MENU_ITEMS.find((item) => item.name.toLowerCase().includes(type) && item.id === id) ? true : false;
  }, [MENU_ITEMS]);

  const onTitleDocs = useCallback(() => {

    const data: IDocumentGenerate = {
      dealId: params.dealId,
      documentGenerationType: docMenuItem?.docTypeId || 0,
      ignoreProducts: true,
      isEmailCustomerTitleDocGen: isMenuItemNeedAction(EMAIL, docMenuItem.id) || isMenuItemNeedAction(STIPS, docMenuItem.id),
      isScanStipTitleDocGen: isMenuItemNeedAction(STIPS, docMenuItem.id),
      filterDocumentTypeIds: filterDocumentTypeIds,
    };
    onDocGenerate(data, docMenuItem);
    setStateMatchAlert(false);
    setOpenTitleAlert(false);
  }, [docMenuItem, params.dealId, filterDocumentTypeIds]);

  const openStateMatchAlert = useCallback((shouldSaveAsset = false) => {
    setNameMatchAlert(false);
    if (shouldSaveAsset) {
      const payload = {
        ...asset,
        assetRegistration: {
          ...asset?.assetRegistration,
          isPrimaryChange: shouldSaveAsset
        }
      };
      requestUpdateAsset(payload as IAsset, true);
    }
    const contactState = contact?.addresses.filter((a) => a.isCurrent)[0]?.state || '';
    if (contactState !== asset?.assetRegistration?.state) {
      setContactState(contactState);
      setStateMatchAlert(true);
    } else {
      onTitleDocs();
    }
  }, [contact, asset, onTitleDocs]);

  const handleNamesClose = useCallback((event: object, reason?:string) => {
    if (!reason) {
      openStateMatchAlert(true);
    } else if (reason === CloseReasons.CLOSE_ICON) {
      setOpenTitleAlert(false);
      setNameMatchAlert(false);
    }
  }, []);

  const handleAssetClose = useCallback((event: object, reason?:string) => {
    if (!reason || reason === CloseReasons.CLOSE_ICON) {
      setStateMatchAlert(false); 
      setOpenTitleAlert(false);
    }
    
  }, []);

  return (
    <>
      <AlertModal
        title="Names Match ?"
        cancelButtonText="No"
        buttonText="Yes"
        open={nameMatchAlert}
        subtitle={`${contact?.firstName} ${contact?.lastName} matches 
            ${asset?.assetRegistration?.primaryOwner || ''} ?`}
        onConfirm={openStateMatchAlert}
        onClose={handleNamesClose}
      />

      <AlertModal
        title="Asset State Match ?"
        subtitle={`${contactState} doesn't match registration state ${asset?.assetRegistration?.state || ''} `}
        buttonText="Ok"
        cancelButtonText="Cancel"
        open={stateMatchAlert}
        onConfirm={onTitleDocs}
        onClose={handleAssetClose}
      />
    </>
  );
};
